import * as React from 'react';

import styles from './styles.css';

export const RotatingArc = () => {
  return (
    <svg className={styles['rotating-arc']} viewBox="0 0 41 40">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="var(--surface-positive-default)" stopOpacity="1" />
          <stop offset="100%" stopColor="var(--control-positive-primary-default)" stopOpacity="1" />
        </linearGradient>
      </defs>
      <path className={styles['arc-path']} d="M 20.5 2 A 18 18 0 0 1 20.5 38" />
    </svg>
  );
};
